import type { EditorState } from 'draft-js';

export const isStyleApplied = (style: string, editorState: EditorState) => {
    const currentStyle = editorState.getCurrentInlineStyle();
    return currentStyle.has(style);
};
